import { useMsal } from '@azure/msal-react'
import { Loader, Stack, Text, Title } from '@mantine/core'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AdConfiguration from '../components/location/AdConfiguration'
import { fetchDeviceById } from '../data/device.service'
import { fetchLocationById } from '../data/location.service'
import { Device } from '../models/Device'
import { Location } from '../models/Location'

const ConfigureAdPage = () => {
  const { deviceId } = useParams<{ deviceId: string }>()
  const { instance } = useMsal()
  const navigate = useNavigate()
  const [device, setDevice] = useState<Device | null>(null)
  const [location, setLocation] = useState<Location | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!deviceId) {
      setError(true)
      setLoading(false)
      return
    }

    let cancelled = false

    fetchDeviceById(deviceId)
      .then((d) => {
        if (cancelled) return
        return fetchLocationById(String(d.locationId), instance).then((l) => {
          if (cancelled) return
          setDevice(d)
          setLocation(l)
        })
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [deviceId, instance])

  if (loading) {
    return (
      <Stack align='center' justify='center' h='100%' pt='xl'>
        <Loader />
      </Stack>
    )
  }

  if (error || !device || !location) {
    return (
      <Stack align='center' justify='center' h='100%' pt='xl'>
        <Text c='red'>Failed to load ad configuration. Please try again.</Text>
      </Stack>
    )
  }

  return (
    <Stack maw={860} mx='auto' w='100%' p={{ base: 'md', sm: 'xl' }} pb={100} mih='calc(100vh - 80px)'>
      <Title size='h2'>
        {location.name} — {device.name}
      </Title>
      <AdConfiguration
        device={device}
        businessHours={location.businessHours}
        onCompletion={() => navigate('/cart')}
        onCancel={() => navigate(-1)}
      />
    </Stack>
  )
}

export default ConfigureAdPage
